export {LoginInfoComponent} from './login-info'
export {UserService} from './user.service'
export {UserModule} from './user.module'



// WEBPACK FOOTER //
// ./src/app/shared/user/index.ts